package devxertech.com.pages.services.devOperation.devService

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.TeamService
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px


@Composable
fun DevServices() {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = if (breakpoint > Breakpoint.MD) 60.px else 30.px,
                bottom = if (breakpoint < Breakpoint.MD) 10.px else 30.px),
        contentAlignment = Alignment.Center
    ) {
        val spanTextModifier = Modifier
            .fontFamily(Constants.ROBOTO_FONT)
            .fontSize(if (breakpoint > Breakpoint.MD) 35.px else 20.px)
            .lineHeight(if (breakpoint > Breakpoint.MD) 37.4.px else 36.px)
            .letterSpacing(0.5.px)
            .textTransform(TextTransform.Uppercase)

        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(text = "DEvOps Services", modifier = Modifier
                .fontFamily(Constants.FONT_FAMILY)
                .fontSize(18.px)
                .color(sitePalette.commonSecondaryButtonColor.rgb)
                .fontWeight(FontWeight.Medium)
                .lineHeight(15.4.px)
                .textTransform(TextTransform.Uppercase)
                .padding(bottom = if (breakpoint < Breakpoint.MD) 0.px else 10.px))
            Row(
                modifier = Modifier.flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                SpanText(text = "What we ", modifier = spanTextModifier
                    .color(sitePalette.commonSecondaryButtonColor.rgb)
                    .fontWeight(FontWeight.ExtraBold)
                )
                SpanText(text = "Offer?", modifier = spanTextModifier
                    .color(sitePalette.primary.rgb)
                    .fontWeight(FontWeight.ExtraBold)
                )
            }
        }
    }
    Row(
        modifier = Modifier.fillMaxWidth()
            .padding(bottom = if (breakpoint < Breakpoint.MD) 10.px else if (window.screen.width > 1600) 10.px else 80.px).flexWrap(FlexWrap.Wrap),
        horizontalArrangement = Arrangement.Center
    ) {
        TeamService(
            image = Res.Image.dev_1,
            title = "Infrastructure Management",
            description = "Prioritize clear navigation, readable fonts, and responsive layouts that work well across all devices.\n" +
                    " We considers ease of use, loading speed, and logical layout to keep users engaged.",

            )
        TeamService(
            image = Res.Image.dev_2,
            title = "Configuration Management",
            description = "Fully automated, standardized and error-free, " +
                    "our configuration management services boost collaboration between the Development and Operations teams and enables consistency in all the setups."

        )

        TeamService(
            image = Res.Image.dev_3,
            title = "Code Inspection & Integration",
            titleFontSize = 16.px,
            description = "Our code inspection and integration services improve overall code quality and support all the DevOps team, making the final product efficient, up to date and perfectly aligned with the business objectives.",

            )
        if (window.screen.width < 1600) {
            TeamService(
                image = Res.Image.dev_4,
                title = "DevOps Automation Service",
                description = "Our automation services for DevOps requires least human efforts in the system’s repetitive and manual tasks allowing a smooth workflow and a more synergized environment of machines, virtual machines and humans.",
            )


            TeamService(
                image = Res.Image.dev_5,
                title = "Staff Augmentation",
                description = "Staff augmentation services are also available when a certain project displays gaps and needs more workforce to be completed in a particular manner",
                modifier = Modifier.padding(bottom = 80.px)

                )
            TeamService(
                image = Res.Image.dev_6,
                title = "Virtualization",
                description = "Our main goal is to provide high quality product that stays at its optimum throughout all the stages of software development and delivers every feature with excellence. We use virtualization services in DevOps maintains the overall quality of the software and the capabilities of a system."

            )
        }
    }
    if (window.screen.width > 1600) {
        Row(modifier = Modifier.fillMaxWidth()
            .padding(top = 0.px, bottom = if (window.screen.width > 1600) 40.px else 70.px).display(DisplayStyle.Flex)
            .flexWrap(FlexWrap.Wrap),
            horizontalArrangement = Arrangement.Center
        ) {
            TeamService(
                image = Res.Image.dev_4,
                title = "DevOps Automation Service",
                description = " Our automation services for DevOps requires least human efforts in the system’s repetitive and manual tasks allowing a smooth workflow and a more synergized environment of machines, virtual machines and humans.",
                modifier = Modifier.padding(bottom = 40.px)

                )
            TeamService(
                image = Res.Image.dev_5,
                title = "Staff Augmentation",
                description = "Staff augmentation services are also available when a certain project displays gaps and needs more workforce to be completed in a particular manner",
                modifier = Modifier.padding(bottom = 80.px)

                )
            TeamService(
                image = Res.Image.dev_6,
                title = "Virtualization",
                description = "Our main goal is to provide high quality product that stays at its optimum throughout all the stages of software development and delivers every feature with excellence. We use virtualization services in DevOps maintains the overall quality of the software and the capabilities of a system.",

            )
        }
    }
}




